/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const NameplateReissue = {
  path: '/nameplate-reissue',
  name: 'nameplate-reissue',
  redirect: { name: 'nameplate-reissue-list' },
  component: () => import('@/views/nameplate-reissue/index.vue'),
  children: [
    {
      path: 'list',
      name: 'nameplate-reissue-list',
      component: () =>
        import(
          /* webpackChunkName: "nameplate-reissue" */ '@/views/nameplate-reissue/nameplate-reissue-list.vue'
        ),
    },
    {
      path: 'detail',
      name: 'nameplate-reissue-detail',
      component: () =>
        import(
          /* webpackChunkName: "nameplate-reissue" */ '@/views/nameplate-reissue/order-detail.vue'
        ),
    },
    {
      path: 'apply',
      name: 'nameplate-reissue-apply',
      component: () =>
        import(
          /* webpackChunkName: "nameplate-reissue" */ '@/views/nameplate-reissue/order-apply.vue'
        ),
    },
    {
      path: 'edit-receipt-info',
      name: 'nameplate-edit-receipt-info',
      component: () =>
        import(
          /* webpackChunkName: "nameplate-reissue" */ '@/views/nameplate-reissue/edit-receipt-info.vue'
        ),
    },
    {
      path: 'confirm-success',
      name: 'nameplate-confirm-success',
      component: () =>
        import(
          /* webpackChunkName: "nameplate-reissue" */ '@/views/nameplate-reissue/confirm-success.vue'
        ),
    },
    {
      path: 'pay-success/:orderNum/:guid/:amount',
      name: 'nameplate-pay-success',
      component: () =>
        import(
          /* webpackChunkName: "nameplate-reissue" */ '@/views/nameplate-reissue/pay-success.vue'
        ),
    },
  ],
}
export default NameplateReissue
